import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import KnowledgeAssetArticleAppResource from './KnowledgeAssetArticleAppResource';
import KnowledgeAssetVideoAppResource from './KnowledgeAssetVideoAppResource';
import KnowledgeBaseAppResource from './KnowledgeBaseAppResource';

class KnowledgeAssetTagAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Knowledge-Asset-Tag';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'knowledge/assets/tags';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'tag',
            'knowledgeBaseUuid',
            'knowledgeBase',
            'videos',
            'articles',
            'faqs',
            'terms',
            'tutorials',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            knowledgeBase: KnowledgeBaseAppResource,
            videos: KnowledgeAssetVideoAppResource,
            articles: KnowledgeAssetArticleAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            knowledgeBase: 'knowledge_base_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            tag: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            knowledgeBaseUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default KnowledgeAssetTagAppResource;
